// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"e9-z"};